import { reactive } from 'vue';

export const criarSim = () => {
    return reactive({
        id: 0,
        idep: 0,
        cdsim: 0,
        nmsim: '',
        nmsecretaria: '',
        cnpj: '',
        endereco: '',
        nmendereco: 0,
        complemento: '',
        bairro: '',
        cep: '',
        idmunicipio: 0,
        fone: '',
        email: '',
        lei_municipal_nro_data: '',
        decreto_municipal_nro_data: '',
        nmlogo: '',
        ativo: '',
        rptitulo: '',
        rpsubtitulo: '',
        latitude: 0,
        longitude: 0,
        idlogin: 0,
    })
}
